import { render, staticRenderFns } from "./Amis.vue?vue&type=template&id=8f205306&scoped=true"
import script from "./Amis.vue?vue&type=script&lang=js"
export * from "./Amis.vue?vue&type=script&lang=js"
import style0 from "./Amis.vue?vue&type=style&index=0&id=8f205306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f205306",
  null
  
)

export default component.exports